/** @format */

import UIkit from "uikit";
// Add your JS customizations here
(function (m, t) {
  "use strict";
  function v(e) {
    return e && typeof e == "object" && "default" in e ? e : { default: e };
  }
  var s = v(m);
  function p(e, n) {
    if (!!e) {
      if (typeof e == "string") return f(e, n);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (
        (r === "Object" && e.constructor && (r = e.constructor.name),
        r === "Map" || r === "Set")
      )
        return Array.from(e);
      if (
        r === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
      )
        return f(e, n);
    }
  }
  function f(e, n) {
    (n == null || n > e.length) && (n = e.length);
    for (var r = 0, a = new Array(n); r < n; r++) a[r] = e[r];
    return a;
  }
  function b(e, n) {
    var r =
      (typeof Symbol != "undefined" && e[Symbol.iterator]) || e["@@iterator"];
    if (r) return (r = r.call(e)).next.bind(r);
    if (
      Array.isArray(e) ||
      (r = p(e)) ||
      (n && e && typeof e.length == "number")
    ) {
      r && (e = r);
      var a = 0;
      return function () {
        return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var c = {
      connected: function () {
        var n = this;
        (this.section = d()),
          this.section ||
            this.registerObserver(
              t.observeMutation(
                document.body,
                function (r, a) {
                  (n.section = d()), n.section && (a.disconnect(), n.$emit());
                },
                { childList: !0, subtree: !0 }
              )
            );
      },
    },
    $ = {
      mixins: [c],
      connected: function () {
        var n = this;
        this.registerObserver(
          t.observeResize(this.$el, function () {
            return n.$emit("resize");
          })
        );
      },
      update: [
        {
          read: function () {
            return !o(this.section) || !this.$el.offsetHeight
              ? !1
              : { height: this.$el.offsetHeight };
          },
          write: function (n) {
            var r = n.height;
            if (!t.hasClass(this.$el, "tm-header-overlay")) {
              var a = o(this.section);
              t.addClass(this.$el, "tm-header-overlay"),
                t.addClass(
                  t.$$(
                    ".tm-headerbar-top, .tm-headerbar-bottom, .js-toolbar-transparent"
                  ),
                  "uk-" + a
                ),
                t.removeClass(
                  t.$$(".tm-headerbar-top, .tm-headerbar-bottom"),
                  "tm-headerbar-default"
                ),
                t.removeClass(
                  t.$(".js-toolbar-transparent.tm-toolbar-default"),
                  "tm-toolbar-default"
                ),
                t.$("[uk-sticky]", this.$el) ||
                  t.addClass(
                    t.$(".uk-navbar-container", this.$el),
                    "uk-navbar-transparent uk-" + a
                  );
            }
            t.css(t.$(".tm-header-placeholder", this.section), { height: r });
          },
          events: ["resize"],
        },
      ],
    },
    y = {
      mixins: [c],
      update: {
        read: function () {
          var n = o(this.section);
          if (!(!n || !t.closest(this.$el, "[uk-header]")))
            return (
              (this.animation = "uk-animation-slide-top"),
              (this.clsInactive = "uk-navbar-transparent uk-" + n),
              this.active || t.addClass(this.selTarget, this.clsInactive),
              {
                start:
                  this.section.offsetHeight <= t.toPx("100vh")
                    ? t.offset(this.section).bottom
                    : t.offset(this.section).top + 300,
              }
            );
        },
        events: ["resize"],
      },
    };
  function d() {
    return t.$(
      '.tm-header ~ [class*="uk-section"], .tm-header ~ :not(.tm-page) > [class*="uk-section"]'
    );
  }
  function o(e) {
    return t.attr(e, "tm-header-transparent");
  }
  if (
    (s.default.component("Header", $),
    s.default.mixin(y, "sticky"),
    s.default.mixin(
      {
        events: {
          beforescroll: function () {
            if (!this.$props.offset)
              for (
                var n = b(t.$$("[uk-sticky] [uk-navbar]")), r;
                !(r = n()).done;

              ) {
                var a = r.value;
                t.isVisible(a) && (this.offset = a.offsetHeight);
              }
          },
        },
      },
      "scroll"
    ),
    t.isRtl)
  ) {
    var h = {
      created: function () {
        this.$props.pos = t.swap(this.$props.pos, "left", "right");
      },
    };
    s.default.mixin(h, "drop"), s.default.mixin(h, "tooltip");
  }
  t.ready(function () {
    var e = window,
      n = e.$load,
      r = n === void 0 ? [] : n,
      a = e.$theme,
      g = a === void 0 ? {} : a;
    function u(i, l) {
      i.length &&
        i.shift()(l, function () {
          return u(i, l);
        });
    }
    u(r, g);
  });
})(UIkit, UIkit.util);

// UIkit.util.on("dropbar", "show", function () {
//   // do something
//   console.log("test");
// });

(function () {
  // Replace the selector with the selector of your drop component
  const dropElements = document.querySelectorAll(".uk-navbar-dropdown.dropbar");
  dropElements.forEach((dropElement) => {
    UIkit.util.on(dropElement, "show", () => {
      document.body.classList.add("drop-open");
    });

    UIkit.util.on(dropElement, "hide", () => {
      document.body.classList.remove("drop-open");
    });
  });
})();

// document.addEventListener('DOMContentLoaded', function() {
//   UIkit.accordion(document.querySelector('.uk-accordion'));
// });